import React from 'react';
import WebCategoryList from '../components/settings/WebCategoryList';
import { useLanguage } from '../contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { GlobeAltIcon } from '@heroicons/react/24/outline';

const WebCategories = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-4 pb-20 sm:pb-6">
      <CommonPageHeader
        title="Webshop Kategóriák"
        subtitle="Webshop kategóriák kezelése - ezek jelennek meg a frontend-en"
        icon={GlobeAltIcon}
      />
      <WebCategoryList />
    </div>
  );
};

export default WebCategories;
